export const jobDetailsPageRegex = /^\/job(\/.*)?$/;
export const searchResultsPageRegex = /(^\/.*jobs.*$)|(^\/*-jobs-jobs)/;
export const homePageRegex = /^\/$/;
export const expiredJobPageRegex = /^\/expiredjob(\/.*)?$/;
